<nav class="ui-breadcrumb" *ngIf="items.length">
  <ng-container *ngFor="let item of items; let last = last">
    <span class="ui-breadcrumb__item" [class.ui-breadcrumb__item--current]="last">{{ item.label }}</span>
    <span class="ui-breadcrumb__sep" *ngIf="!last">&gt;</span>
  </ng-container>
</nav>
